export default {
    autoHide: Boolean,
    animation: Boolean | Object,
    content: String | Function | Object,
    callout: Boolean,
    filter: String,
    iframe: Boolean,
    height: Number,
    width: Number,
    position: String,
    showAfter: Number,
    showOn: String,
    hideAfter: Number,
    offset: Number,

    // Events
    contentLoad: Function,
    show: Function,
    hide: Function,
    requestStart: Function,
    error: Function
}


// WEBPACK FOOTER //
// ./packages/kendo-popups-vue-wrapper/src/KendoTooltip/TooltipProps.js